import superagent from 'superagent'

import {
  HttpMethods,
  NetworkHandler,
  NetworkInterface,
  NetworkOptions,
  ResponseBody,
  ResponseHeaders,
  ResponseStatus,
  ResponseText,
  Url,
} from './types'

const createRequest = (url: Url, method: HttpMethods, body: any) => {
  const methodHandler = (superagent as any)[String(method).toLowerCase()]
  if (!methodHandler) {
    throw new Error(`Unsupported HTTP method: ${method}`)
  } else {
    return methodHandler(url, body)
  }
}

function isBlob(mime: string): boolean {
  return [
    'text/csv',
    'application/pdf',
    'application/octet-stream',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ].some(type => {
    return mime.includes(type)
  })
}

function _getResponseType(str?: string): XMLHttpRequestResponseType {
  if (str) {
    const list = str.split(',')

    for (let j = 0, len = list.length; j < len; j += 1) {
      const mime = list[j].trim()

      if (isBlob(mime)) {
        return 'blob'
      }
    }
  }

  return ''
}

const getResponseType = (contentType?: string, accept?: string): XMLHttpRequestResponseType =>
  _getResponseType(contentType) || _getResponseType(accept)

type ExecuteCallback = (
  error: any,
  status: ResponseStatus,
  responseBody?: ResponseBody,
  responseText?: ResponseText,
  responseHeaders?: ResponseHeaders,
) => void

export const superagentNetworkInterface: NetworkInterface = (
  url: Url,
  method: HttpMethods,
  {body, headers, credentials}: NetworkOptions = {},
): NetworkHandler => {
  const request = createRequest(url, method, body)

  if (headers) {
    request.set(headers)
  }

  if (credentials === 'include') {
    request.withCredentials()
  }

  const responseType = getResponseType(request.get('content-type'), request.get('accept'))

  if (responseType) {
    request.responseType(responseType)
  }

  const execute = (cb: ExecuteCallback) =>
    request.end((err: Error, response: Response) => {
      const resStatus = (response && response.status) || 0
      const resBody = (response && response.body) || undefined
      const resText = (response && (response.text as any)) || undefined
      const resHeaders = (response && (response.headers as any)) || undefined

      cb(err, resStatus, resBody, resText, resHeaders)
    })

  const abort = () => request.abort()

  return {
    abort,
    execute,
  }
}
